<template>
    <v-dialog
    v-model="show"
    width="500"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Problema no upload de .zip
      </v-card-title>

      <v-card-text v-if="content == 'invalid-files'">
        <p><strong>Há arquivos inválidos dentro do seu arquivo .zip.</strong></p>
        <p>Por favor, certifique-se de que as imagens estão na raíz do arquivo e de que são todas em um dos seguintes formatos:</p>
        <ul>
          <li>.jpg</li>
          <li>.jpeg</li>
          <li>.gif</li>
          <li>.tiff</li>
          <li>.tif</li>
        </ul>
      </v-card-text>

      <v-card-text v-if="content == 'invalid-qtt'">
        <p><strong>A quantidade de imagens dentro do seu arquivo .zip excede o máximo previsto pelo seu plano.</strong></p>
        <div v-if="qttData">
          <p>Quantidade de imagens previstas pelo seu plano:</p>
          <ul>
            <li>Templates RGB: {{ qttData.max_img_rgb }}</li>
            <li>Template Multiespectral: {{ qttData.max_img_multispectral }}</li>
          </ul>
        </div>
      </v-card-text>

      <v-card-text v-if="content == 'invalid-files-chars'">
        <p><strong>Há arquivos inválidos dentro do seu arquivo .zip.</strong></p>
        <p>Seu arquivo .zip possui arquivos que apresentam nomes com caracteres especiais ou espaços!</p>
      </v-card-text>

      <v-card-text v-if="content == 'invalid-zip-file'">
        <p><strong>Arquivo .zip inválido.</strong></p>
        <p>Seu arquivo .zip possui um nome com caracteres especiais ou espaços.</p>
      </v-card-text>

      <v-card-text v-if="content == 'length-images-in-zip'">
        <p><strong>Arquivo .zip com quantidade de imagens insuficiente.</strong></p>
        <p>Apenas é possível criar um processamento do tipo 'Imagens de Drone' com mais de 8 imagens dentro do zip.</p>
      </v-card-text>      

      <v-card-text v-if="content == 'not-get-metadata-exif'">
        <p><strong>Há arquivos inválidos dentro do seu arquivo .zip.</strong></p>
        <p>Seu arquivo .zip possui arquivos sem o geotageamento</p>
      </v-card-text>      

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="emitClose"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UploadIssueDialog",
  props: ["show", "content", "qttData"],
  methods: {
    emitClose() {
      this.$emit("close")
    }
  }
}
</script>
